module.exports = __webpack_public_path__ + "img/cloth_g1_shoe_07.7f035362.svg";